import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import FastfoodIcon from '@mui/icons-material/Fastfood';
import {Observer} from "mobx-react-lite";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import Box from "../../../ui_components/Box/Box";
import Width from "../../../ui_components/common/enums/Width";
import Alignment from "../../../ui_components/common/enums/Alignment";
import ShowPagination from "../../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../../ui_components/MessageCard/MessageCard";
import ShowSellerBasicInfo from "../../Info/ShowSellerBasicInfo/ShowSellerBasicInfo";
import SidePanel from "../../../ui_components/SidePanel/SidePanel";
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";
import ArticleWarehouseStockButtonProperties from './ArticleWarehouseStockButtonProperties';
import { useStyles } from './ArticleWarehouseStockButton.style';
import AddArticleStockButton from '../../Buttons/AddArticleStockButton/AddArticleStockButton';
import Article from '../../../entities/Article';
import Currency from '../../../entities/Currency';
import RoundedButton from '../../../ui_components/RoundedButton/RoundedButton';
import Button from '../../../ui_components/Button/Button';
import ButtonSize from '../../../ui_components/Button/ButtonSize';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import ShowText from '../../Info/ShowText/ShowText';
import ArticleWarehouseStockStore from './ArticleWarehouseStockStore';
import ShowImage from '../../Info/ShowImage/ShowImage';
import TransferArticleFromWarehouseButton from '../TransferArticleFromWarehouseButton/TransferArticleFromWarehouseButton';
import DownloadArticleStockCSVButton from '../DownloadArticleStockCSVButton/DownloadArticleStockCSVButton';
import ShowArticleStock from '../../Info/ShowArticleStock/ShowArticleStock';
import ShowArticleDamagedStock from '../../Info/ShowArticleDamagedStock/ShowArticleDamagedStock';
import ArticleSelect from '../../Selects/ArticleSelect/ArticleSelect';

const ArticleWarehouseStockButton: React.FC<ArticleWarehouseStockButtonProperties> = ({
                                                                        showIcon = true,
                                                                        showText = true,
                                                                        disabled,
                                                                        className = '',
                                                                        rounded = false,
                                                                        articleWarehouse,
                                                                        onClose = () => {
                                                                        },
                                                                        size = ButtonSize.DEFAULT,
                                                                        type = ButtonType.DEFAULT
                                                                    }) => {
    const classes = useStyles();

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new ArticleWarehouseStockStore(commonContext, articleWarehouse);

    const handleOnclick = async () => {
        await store.openModal();
    }

    const onCloseModal = () => {
        store.closeModal();
        onClose();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await store.goToPage(page, pageSize);
    }

    const onCostSaved = async () => {
        await store.goToPage()
    }

    const onArticleChange = (newArticle?: Article) => (store.articleFilter = newArticle);
    
    const clearFilter = async () => {
        await store.clearFilter()
    }

    const text = 'Inventario de Artículos';
    if (!userStore.hasAccess(Access.ADD_DELIVERY_COST.valueOf())) {
        return <></>;
    }
    
    const btnIcon = <WarehouseIcon />;
    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? btnIcon : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? btnIcon : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <SidePanel loading={store.loading} title={text} onClose={onCloseModal} open={store.isModalOpen}
                           className={classes.modal_container}>
                    <div className={classes.contacts_container}>
                        <div className={classes.body}>
                            <Box
                                width={Width.FULL_WIDTH}
                                justifyContent={Alignment.SPACE_BETWEEN}>
                                <ShowSellerBasicInfo name={store.articleWarehouse.name} autofill/>
                                <AddArticleStockButton
                                    type={ButtonType.SECONDARY}
                                    onSave={onCostSaved}
                                    entityId={store.articleWarehouse.id}/>
                            </Box>

                            <Box className={classes.filter_container} width={Width.FULL_WIDTH}
                                justifyContent={Alignment.SPACE_BETWEEN}>
                                <div className={classes.filter_items_container}>
                                    <ArticleSelect
                                        fullWidth
                                        label={'Artículo'}
                                        selected={store.articleFilter}
                                        onChange={onArticleChange}/>
                                </div>
                                <div className={classes.filter_buttons_container}>
                                    <Button
                                        onClick={() => {
                                            store.getArticlesStock()
                                        }}
                                        className={classes.search_btn}
                                        type={ButtonType.PRIMARY}
                                        text={i18n.translate("SEARCH")}
                                    />
                                    <Button
                                        onClick={clearFilter}
                                        className={classes.search_btn}
                                        text={i18n.translate("CLEAN")}
                                    />
                                </div>
                            </Box>

                            <Box className={classes.options_buttons_container}>
                                <TransferArticleFromWarehouseButton
                                    articleWarehouse={store.articleWarehouse}
                                    type={ButtonType.SECONDARY}
                                    onSave={onCostSaved}
                                />
                                <DownloadArticleStockCSVButton
                                    id={articleWarehouse.id}
                                    disabled={store.isEmpty}
                                    type={ButtonType.SECONDARY}
                                />
                            </Box>

                            {!store.isEmpty &&
                            <div className={classes.contacts_table}>
                                <ShowPagination onChange={onPaginationChange}
                                                elementLabel={'Artículos'}
                                                pagination={store.pagination}/>
                                <div>
                                    {store.articlesStock.map((articleStock, i) => (
                                        <div className={classes.cost_info_container}>
                                            <ShowImage imageName={articleStock.articleDefaultImage} width={70} height={70}/>
                                            <ShowText text={articleStock.articleName} className={classes.article_name_container}/>
                                            <div className={classes.amount_container}>
                                                <ShowArticleStock amount={articleStock.amount} damagedAmount={articleStock.damagedAmount} assignedAmount={articleStock.assignedAmount} />
                                                <div className={classes.add_btn_link}>
                                                    <AddArticleStockButton
                                                        type={ButtonType.SECONDARY}
                                                        rounded
                                                        onSave={onCostSaved}
                                                        entityId={store.articleWarehouse.id}
                                                        isLinkText={true}
                                                        selectedArticle={new Article(
                                                            articleStock.articleId,
                                                            articleStock.articleName,
                                                            '', '', '',
                                                            articleStock.articleDefaultImage,
                                                            0,
                                                            Currency.DOLLAR,
                                                            0,
                                                            0,
                                                            0,
                                                            0,
                                                            0
                                                        )}
                                                    />
                                                </div>
                                                <ShowArticleDamagedStock
                                                    damagedAmount={articleStock.damagedAmount}
                                                    entityId={store.articleWarehouse.id}
                                                    articleId={articleStock.articleId}
                                                    onSave={onCostSaved}
                                                />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <ShowPagination
                                    onChange={onPaginationChange}
                                    elementLabel={'Artículos'}
                                    pagination={store.pagination}/>
                            </div>
                            }
                            {store.isEmpty &&
                            <MessageCard icon={FastfoodIcon} title={i18n.translate("NO_ARTICLE_STOCK_TITLE")}/>}
                        </div>
                    </div>
                </SidePanel>
                <Btn/>
            </>
        )}
    </Observer>
}

export default ArticleWarehouseStockButton;
